export default class TimeUtils {
  static parseUTC(input: string | number | Date): Date {
    if (input instanceof Date) {
      return new Date(input.getTime());
    }

    if (typeof input === 'string') {
      const hasTZ = /Z$|[+-]\d\d:\d\d$/.test(input);
      return hasTZ ? new Date(input) : new Date(input + 'Z');
    }

    if (typeof input === 'number') {
      return new Date(input);
    }

    return new Date(NaN);
  }
}
